import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "crz-container" }
const _hoisted_2 = { class: "f-24 sz-primary-grey--text font-weight-medium" }
const _hoisted_3 = { class: "prepend-required f-14 sz-secondary-grey--text mb-0" }
const _hoisted_4 = { key: 0 }

import CheckboxField from '@/components/widgets/Inputs/CheckboxField.vue';
import { useConsentStore } from '@/stores/Consent';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CRZ',
  props: {
    "modelValue": { default: () => ({}) },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const modelValue = _useModel<Record<string, boolean>>(__props, "modelValue");

const consentStore = useConsentStore();

const splittedLabelConsentFields = computed(() => {
    return consentStore.getSplittedLabelConsentFields;
});

const isCheckbox = (type: string): boolean => type === 'checkbox';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('form.consentsTitle')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('label.consentsRequired')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splittedLabelConsentFields.value, (field, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (isCheckbox(field.type))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CheckboxField, {
                modelValue: modelValue.value[field.name],
                "onUpdate:modelValue": ($event: any) => ((modelValue.value[field.name]) = $event),
                label: field.options.label,
                required: field.options.required === true,
                name: field.name,
                rules: field.options.required ? 'required' : '',
                "details-text": field.options.details
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "required", "name", "rules", "details-text"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})